import ContentCard from "./ContentCard"

export default function OneStory({ data }) {
  return <ContentCard data={data} type="Story" viewer="view-story" />
}
